import React, { ReactNode } from "react";
import { useDiary } from "@/context/DiaryContext";
import { EMOTIONS, Emotion } from "@/constants/emotions";
import styles from "./styles";
import { useNavigate } from "react-router";
import { MarkdownReader } from "@/components/dataDisplay/MarkdownReader";

export default function DailyTips() {
  const navigate = useNavigate();
  const { diaryData, isLoadingAIResponse } = useDiary();

  const emotion =
    EMOTIONS.find((e) => e.id === (diaryData.feeling as Emotion["id"])) || null;

  const handleBack = () => {
    navigate("/records/daily-reason");
  };

  const handleNext = () => {
    navigate("/records/daily-finish");
  };

  return (
    <div style={styles.contentContainer}>
      <div style={{ ...styles.scrollContainer, overflowY: "auto" }}>
        <h1 style={styles.title}>Consejos</h1>
        {/* Emotion */}
        {emotion && (
          <div style={styles.section}>
            <h2 style={styles.sectionLabel}>Cómo te sientes:</h2>
            <div style={styles.emotionContainer}>
              {emotion.Icon({}) as ReactNode}
              <div style={{ marginLeft: 12 }}>
                <p style={styles.emotionLabel}>{emotion.label}</p>
                <p style={styles.emotionDescription}>{emotion.description}</p>
              </div>
            </div>
          </div>
        )}

        {/* User entry */}
        {diaryData.description && (
          <div style={styles.section}>
            <h2 style={styles.sectionLabel}>Tu entrada:</h2>
            <p style={styles.entryText}>{diaryData.description}</p>
          </div>
        )}

        {/* AI comment */}
        <div style={styles.section}>
          <h2 style={styles.sectionLabel}>Comentario:</h2>
          {isLoadingAIResponse ? (
            <div style={styles.loadingContainer}>
              {/* <LoadingIndicator /> */}
              <p style={styles.aiResponseText}>Cargando respuesta...</p>
            </div>
          ) : (
            <MarkdownReader>
              {diaryData.aiResponse || "No hay respuesta aún."}
            </MarkdownReader>
          )}
        </div>
      </div>

      {/* Buttons */}
      <div style={styles.buttonsContainer}>
        <button
          style={styles.backButton}
          onClick={handleBack}
          disabled={isLoadingAIResponse}
        >
          <span style={styles.backButtonText}>Atrás</span>
        </button>

        <button
          style={styles.nextButton}
          onClick={handleNext}
          disabled={isLoadingAIResponse}
        >
          <span style={styles.nextButtonText}>Siguiente</span>
        </button>
      </div>
    </div>
  );
}
